<template>
  <div class="item-box-content">
    <el-row>
      <el-col :span="12">
        <div>
          <span class="bold"></span>
          <span class="basic">采购清单</span>
        </div>
      </el-col>
      <el-col
        :span="12"
        style="text-align:right;"
        v-show="$route.query.type !== '审核通过待签署'&&$route.query.type !== '已作废'"
      >
       <el-button
         v-show="$route.query.type === '生成合同'"
          @click="batchSettingType"
          type="primary"
          plain
        >批量设置类型</el-button>
        <el-button
          v-show="$route.query.type === '待审核'"
          @click="onBatchSetRemind"
          type="primary"
          plain
        >批量设置提醒</el-button>
        <el-checkbox
          v-show="$route.query.type !== '盖章审批'"
          @change="checkbox(checked)"
          v-model="checked"
          style="padding-left:20px;"
        >开启货期提醒，到达约定时间后发送站内消息</el-checkbox>
      </el-col>
    </el-row>
    <div class="product-list-box">
      <div>
        <el-table
          ref="custromTableRef"
          :data="list"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          max-height="378"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
          border
          >
          <el-table-column type="selection"></el-table-column>
          <el-table-column prop="brandName" width="100px" label="品牌" show-overflow-tooltip></el-table-column>
          <el-table-column prop="seriesName" width="100px" label="系列" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proName" width="100px" label="产品名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proModel" width="100px" label="型号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proOrdernum" width="100px" label="订货号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="pccCount" width="100px" label="数量" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proUnit" width="100px" label="单位" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proExtype" width="120px" label="类型">
            <template slot-scope="scope">
              <span v-if="contractFrom ==='直备采购'&& $route.query.type === '待审核'">
                <el-select @change="contractFromChange(scope.$index)" v-model="scope.row.proExtype">
                  <el-option value="现货" label="现货"></el-option>
                  <el-option value="期货" label="期货"></el-option>
                </el-select>
              </span>
              <span v-else>{{scope.row.proExtype}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pcbExtimeValue" width="150px" label="货期">
            <template slot-scope="scope">
              <span>{{scope.row.pcbExtimeValue || '--'}}</span>
              <span v-if='scope.row.pcbExtimeValue'>天</span>
              <!-- <span>{{scope.row.pcbExtimeValue === null ? '':'天'}}</span> -->
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="cbRemind" label="提醒" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                class="approval"
                @click="cbRemindSet(scope.row, scope.$index)"
                v-if="
                  scope.row.cbRemind === null && $route.query.type === '待审核'
                "
              >请设置提醒时间</span>
              <span
                @click="cbRemindSet(scope.row, scope.$index)"
                v-if=" $route.query.type !== '待审核'"
              >{{scope.row.cbRemind||"--"}}</span>
              <span
                v-if="scope.row.cbRemind !== null && $route.query.type === '待审核'"
                class="approval"
                @click="cbRemindSet(scope.row, scope.$index)"
              >{{ scope.row.cbRemind}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="purchasePrice" label="采购单价" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.purchasePrice| priceFilterNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="discountPrice" label="抵扣金额">
            <template slot-scope="scope">
              <el-input-number
                v-show="$route.query.type === '待审核'"
                v-model="scope.row.discountPrice"
                @blur="blurDiscountPrice(scope.$index)"
                :controls="false"
                style="width:100%;"
                :min="0"
                :max="scope.row.purchasePrice"
                :precision="2"
              ></el-input-number>
              <span
                v-show="$route.query.type !== '待审核'"
              >{{ scope.row.discountPrice| priceFilterNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actuallyPirce" label="实付单价">
            <template slot-scope="scope">
              <el-input-number
                v-show="$route.query.type === '待审核'"
                v-model="scope.row.actuallyPirce"
                :min="0"
                @blur="blurActuallyPirce(scope.$index)"
                :max="scope.row.purchasePrice"
                :controls="false"
                style="width:100%;"
                :precision="2"
              ></el-input-number>
              <span
                v-show="$route.query.type !== '待审核'"
              >{{ scope.row.actuallyPirce| priceFilterNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="proPrice" label="面价" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.proPrice| priceFilterNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="140"
            prop="deliveryTime"
            v-if="contractFrom === '采购计划'"
            label="预计发货时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.deliveryTime| dateFilterNum }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <h4 style="padding-left:30px">总计</h4>
      <el-table
        ref="productsEnquiryTableRefs"
        :data="totalList"
        stripe
        border
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTotalTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
       >
        <el-table-column prop="variety" label="产品种类"></el-table-column>
        <el-table-column prop="productAllPrice" label="采购总额">
          <template slot-scope="scope">
            <span>{{ scope.row.productAllPrice| priceFilterNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productdiscountPrice" label="抵扣总额">
          <template slot-scope="scope">
            <span>{{ scope.row.productdiscountPrice| priceFilterNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productPaidPrice" label="实付总额">
          <template slot-scope="scope">
            <span>{{ scope.row.productPaidPrice| priceFilterNum }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="look-text">
        *其中采购单价是供应商的实际报价，提供给销售的供货价。实付单价是实际支付给供应商的价格。如涉及抵扣金额，可手动设置抵扣金额或实付单价，系统会自动算出另一方对应价格。
        <br />计算公式：实付单价=采购单价-抵扣金额
      </div>
    </div>
    <!------------ 设置提醒 ------------>
    <batch-set-remindDialog
      @onSetTimeAll="onSetTimeAll"
      @onSetTime="onSetTime"
      ref="batchSetRemindDialogRefs"
    ></batch-set-remindDialog>
      <el-dialog title="批量设置类型" :visible.sync="typeDisableDialog" width="437px">
    <el-form label-width="100px">
       <el-form-item label="类型：" :rules="filter_rules({required:true})">
        <el-select v-model="type" style="width:240px">
          <el-option label="现货" value="现货"></el-option>
          <el-option label="期货" value="期货"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-center">
      <el-button type="primary" @click="typeOnSubmit">确 定</el-button>
      <el-button @click="typeDisableDialog = false">取 消</el-button>
    </span>
  </el-dialog>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
import {
  queryDelivery,
  updateByIsOpenExtime
} from '@/api/purchase/purchasePlanList'

import batchSetRemindDialog from '@/components/SetReminders/batchSetRemindDialog'
export default {
  components: {
    'batch-set-remindDialog': batchSetRemindDialog
  },
  props: ['deductionAmount'],
  data () {
    return {
      typeDisableDialog: false, // 类型
      type: '', // 类型
      checked: false,
      checkList: [],
      contractFrom: '',
      deliveryList: [],
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      loadingTotalTable: false,
      totalList: [],
      isFuturesPayment: false,
      futuresPaymentList: [], // 期货期款产品清单
      title: '设置期货' // 设置期货弹窗标题
    }
  },
  methods: {
    // 批量设置类型
    batchSettingType() {
      if (this.checkList.length > 0) {
        this.typeDisableDialog = true
      } else {
        this.$message.error('请选择一条或多条数据')
      }
    },
    typeOnSubmit() {
      if (this.type === '') {
        this.$message.error('请选择类型')
      } else {
        this.checkList.forEach(ele => {
          ele.proExtype = this.type
        })
        this.typeDisableDialog = false
        this.onOcExtime()
      }
    },
    // 修改货期合并数量处理
    onOcExtime() {
      const arr = this.list.reduce((obj, item) => {
        const find = obj.find((i) => i.proId === item.proId && +i.pcbExtimeValue === +item.pcbExtimeValue && i.proExtype === item.proExtype)
        const _d = item
        find ? (find.proCount += item.proCount) : obj.push(_d)
        return obj
      }, [])
      this.list = JSON.parse(JSON.stringify(arr))
    },
    checkbox (newVal) {
      let isOpenExtime = false
      if (newVal === true) {
        if (this.$route.query.type === '待审核') {
          this.$emit('inventoryIsTrue', true)
        }
        isOpenExtime = 1
      } else {
        if (this.$route.query.type === '待审核') {
          this.$emit('inventoryIsTrue', false)
        }
        isOpenExtime = 0
      }
      if (this.$route.query.type === '审核中') {
        updateByIsOpenExtime(this.$route.query.pcbId, isOpenExtime)
          .then((res) => {
            if (res.data.code === 200) {
              if (isOpenExtime === 1) {
                this.$message.success('货期提醒已开启')
                this.$emit('update:checked', true)
              } else if (isOpenExtime === 0) {
                this.$message.success('货期提醒已关闭')
                this.$emit('update:checked', false)
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    changeCbExtimeValue (index) {
      this.list[index].cbRemind = null
    },
    // 货期改变时间
    pcbExtimeValue (item, index) {
      let itemParams
      this.deliveryList.forEach((element, index) => {
        if (element.deliveryDate === item) {
          itemParams = element
        }
      })

      this.list[index].cbRemind = itemParams.reminderDate
    },
    // 设置提醒时间传回来的值
    onSetTime (val, index) {
      if (this.list[index].pcbExtimeValue === null) {
        this.$message.error('请先设置货期')
      } else {
        this.list[index].cbRemind = val
      }
    },
    // 设置提醒时间
    cbRemindSet (val, index) {
      if (this.$route.query.type === '待审核') {
        this.$refs.batchSetRemindDialogRefs.onInitial(index)
      }
    },
    contractFromChange (index) {
      this.list[index].cbRemind = null
      this.list[index].pcbExtimeValue = null
    },
    blurActuallyPirce (index) {
      if (this.list[index].actuallyPirce === undefined || isNaN(this.list[index].actuallyPirce)) {
        this.list[index].actuallyPirce = 0.00
      }
      this.list[index].discountPrice =
        this.list[index].purchasePrice - this.list[index].actuallyPirce
    },
    blurDiscountPrice (index) {
      if (this.list[index].discountPrice === undefined || isNaN(this.list[index].discountPrice)) {
        this.list[index].discountPrice = 0.00
      }
      this.list[index].actuallyPirce =
        this.list[index].purchasePrice - this.list[index].discountPrice
    },
    onInitial (val, contractFrom, checked) {
      this.contractFrom = contractFrom
      this.checked = checked
      if (this.$route.query.type === '待审核') {
        queryDelivery()
          .then((res) => {
            if (res.data.code === 200) {
              this.deliveryList = res.data.obj
            }
          })
          .catch((err) => {
            console.log(err)
          })
        this.list = val
        const list = JSON.parse(JSON.stringify(this.list))
        list.forEach((element, index) => {
          this.list[index].actuallyPirce = list[index].purchasePrice
        })
      } else if (
        this.$route.query.type === '审核中' ||
        this.$route.query.type === '盖章审批' ||
        this.$route.query.type === '审核通过待签署' ||
        this.$route.query.type === '审核驳回' ||
        this.$route.query.type === '审核不通过' ||
        this.$route.query.type === '已作废'
      ) {
        const param = {
          variety: val.productClass,
          productAllPrice: val.purchaseTotal,
          productdiscountPrice: val.discountTotal,
          productPaidPrice: val.actualTotal
        }
        this.totalList = []
        this.totalList.push(param)
        const list = val.purchaseUnsignVoList
        this.list = JSON.parse(JSON.stringify(list))
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    onSetTimeAll (val) {
      this.list.forEach((element, index) => {
        this.checkList.forEach((ele, indexs) => {
          if (element.pccId === ele.pccId) {
            this.onSetTime(val, index)
          }
        })
      })
    },
    // 列表数据选中
    handleSelectionChange (row) {
      this.checkList = row
    },

    // 批量设置提醒
    onBatchSetRemind () {
      if (this.checkList.length === 0) {
        this.$message.error('至少选择一个采购清单')
      } else {
        this.$refs.batchSetRemindDialogRefs.onInitial('all')
      }
    },
    // 设置期货
    onSetFutures () {
      this.$refs.setFuturesDialogRefs.onInitial()
    },
    // 期货期款添加产品清单
    addProductList (params) {
      this.futuresPaymentList.push(params)
      this.isFuturesPayment = true
    }
  },
  watch: {
    checked: {
      handler (newVal) { }
    },
    list: {
      handler (newVal) {
        this.totalList = []
        this.totalList.push({
          variety: 0,
          productAllPrice: 0,
          productdiscountPrice: 0,
          productPaidPrice: 0
        })
        this.totalList[0].variety = this.list.length
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].actuallyPirce === undefined || isNaN(this.list[i].actuallyPirce)) {
            this.list[i].actuallyPirce = 0
          } else if (this.list[i].discountPrice === undefined || isNaN(this.list[i].discountPrice)) {
            this.list[i].discountPrice = 0
          }

          this.totalList[0].productAllPrice +=
            this.list[i].purchasePrice * this.list[i].pccCount
          this.totalList[0].productdiscountPrice +=
            this.list[i].discountPrice * this.list[i].pccCount
          this.totalList[0].productPaidPrice +=
            this.list[i].actuallyPirce * this.list[i].pccCount
        }
        // if (this.totalList[0].productdiscountPrice > this.deductionAmount) {
        //   this.$message.error('抵扣总额不能大于供应商抵扣金额！')
        // }
        this.$emit('inventory', this.list, this.totalList[0].productPaidPrice, this.totalList[0].productdiscountPrice)
      },

      deep: true
    }
  },
  filters: {
    dateFilter, dateFilterNum
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
function dateFilterNum (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
</script>
<style lang="scss" scoped>
.product-list-box {
  padding: 20px 0 0;
  .product-list-box-set-futures {
    height: 140px;
    background: rgba(243, 247, 255, 1);
    border-radius: 4px;
  }
}
.look-text {
  margin-top: 20px;
  font-size: 12px;
  line-height: 25px;
  color: #d35e5e;
}
</style>
